import { createContext, useContext, useState } from "react";
import { createStore, useStore } from "zustand";
import { InsertMediaModalData } from "../components/ControlledRichTextEditorInsertMediaModal";

type ControlledRichTextEditorMenuBarType = {
  isLinkMenuVisible: boolean;
  setIsLinkMenuVisible: (isVisible: boolean) => void;
  mediaModalData: InsertMediaModalData;
  setMediaModalData: (data: InsertMediaModalData) => void;
  linkUrl: string;
  setLinkUrl: (url: string) => void;
  linkDisplayText: string;
  setLinkDisplayText: (text: string) => void;
};

export function createControlledRichTextEditorMenuBarStore() {
  return createStore<ControlledRichTextEditorMenuBarType>()((set) => ({
    isLinkMenuVisible: false,
    setIsLinkMenuVisible: (isVisible) => set(() => ({ isLinkMenuVisible: isVisible })),
    mediaModalData: null,
    setMediaModalData: (data) => set(() => ({ mediaModalData: data })),
    linkUrl: "",
    setLinkUrl: (url) => set(() => ({ linkUrl: url })),
    linkDisplayText: "",
    setLinkDisplayText: (text) => set(() => ({ linkDisplayText: text })),
  }));
}

export const ControlledRichTextEditorMenuBarContext = createContext<ReturnType<
  typeof createControlledRichTextEditorMenuBarStore
> | null>(null);

export function ControlledRichTextEditorMenuBarProvider({ children }: { children: React.ReactNode }) {
  const [menuBarStore] = useState(createControlledRichTextEditorMenuBarStore);

  return (
    <ControlledRichTextEditorMenuBarContext.Provider value={menuBarStore}>
      {children}
    </ControlledRichTextEditorMenuBarContext.Provider>
  );
}

export function useControlledRichTextEditorMenuBarStore() {
  const store = useContext(ControlledRichTextEditorMenuBarContext);

  if (!store) {
    throw new Error("useMenuBarStore must be used within a MenuBarProvider");
  }

  return useStore(store);
}
